const React = require("react");
const ReactDOM = require("react-dom");
const App = require("./components/app");

let target = document.querySelector("#app");

ReactDOM.render(<App />, target);
